import ArticleCard from 'components/ArticleCard';
import MaxWidthWrapper from 'components/wrappers/MaxWidthWrapper';
import PropTypes from 'prop-types';
import React from 'react';
import { above } from 'utils/mediaqueries';
import { mediaQueries } from 'config/theme/breakpoints';
import ratios from 'config/theme/ratios';
import styled from 'libs/styled';

const Wrapper = styled('ul')`
    display: flex;
    flex-wrap: wrap;

    @supports (display: grid) {
        display: grid;
        grid-template-columns: 1fr;
        gap: 16px;

        ${above.sm} {
            grid-template-columns: 1fr 1fr;
            gap: 24px;
        }

        ${above.md} {
            grid-template-columns: 1fr 1fr 1fr;
        }
    }
`;

const Designer = styled('li')`
    width: 100%;
    max-width: 100%;
    flex: 0 0 100%;

    ${above.sm} {
        width: 50.5%;
        max-width: 50%;
        flex: 0 0 50%;
    }
    ${above.md} {
        width: 33.33%;
        max-width: 33.33%;
        flex: 0 0 33.33%;
    }

    @supports (display: grid) {
        width: auto !important;
        max-width: none !important;
        flex: none !important;
        min-width: 0;
    }
`;

const DesignerGridLayout = ({ designers = [] }) => {
    if (!designers.length > 0) {
        return null;
    }

    return (
        <MaxWidthWrapper includeContentMargins>
            <Wrapper>
                {designers.map(designer => (
                    <Designer key={designer.id}>
                        <ArticleCard
                            heading={designer.heading}
                            image={designer.background}
                            mediaQuery={mediaQueries.threeColumn}
                            ratio={ratios.vertical}
                            to={designer.to}
                        />
                    </Designer>
                ))}
            </Wrapper>
        </MaxWidthWrapper>
    );
};

DesignerGridLayout.propTypes = {
    designers: PropTypes.array,
};

export default DesignerGridLayout;
